module.exports = __webpack_public_path__ + "static/media/combo.5fed31fe.png";